import { buildWhatsAppLink } from "@/lib/config";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/50 py-10 px-4">
      <div className="max-w-lg mx-auto text-center">
        <p className="font-heading font-bold text-lg text-foreground-950 mb-2">
          kwai<span className="text-primary-500">.</span>ads
        </p>

        <div className="flex items-center justify-center gap-4 mb-4">
          <a
            href="https://www.instagram.com/kwai.ads"
            target="_blank"
            rel="noopener noreferrer"
            className="text-foreground-600 hover:text-primary-400 transition-colors text-sm flex items-center gap-1.5 cursor-pointer"
          >
            <i className="ri-instagram-line"></i>
            @kwai.ads
          </a>
          <a
            href={buildWhatsAppLink("Olá! Vi a bio page do kwai.ads")}
            target="_blank"
            rel="noopener noreferrer"
            className="text-foreground-600 hover:text-primary-400 transition-colors text-sm flex items-center gap-1.5 cursor-pointer"
          >
            <i className="ri-whatsapp-line"></i>
            WhatsApp
          </a>
        </div>

        <p className="text-xs text-foreground-500 leading-relaxed">
          kwai.ads é uma operação independente de gestão de mídia e não representa o Kwai.
        </p>
      </div>
    </footer>
  );
}